window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Pages.Safra = window.FazendaRP.Pages.Safra || {};

window.FazendaRP.Pages.Safra.Colheita = {
    init: async function () {
        const container = document.getElementById('view-romaneios');
        if (!container) return;

        container.innerHTML = `
            <div style="display: grid; grid-template-columns: 1fr 320px; gap: 20px;">
                <!-- Form Inputs -->
                <div style="background:white; border-radius:12px; padding:25px; box-shadow:0 1px 3px rgba(0,0,0,0.05); border:1px solid #e5e7eb;">
                    <h3 style="margin:0 0 20px 0; color:#1e293b; font-weight:600; display:flex; align-items:center; gap:10px;">
                        <i class="fas fa-plus-circle" style="color:#15803d"></i> Nova Entrada de Carga
                    </h3>
                    <form id="form-romaneio" onsubmit="event.preventDefault(); window.FazendaRP.Pages.Safra.Colheita.saveRomaneio();">
                        <div style="display:grid; grid-template-columns:repeat(3, 1fr); gap:15px; margin-bottom:20px;">
                            <div class="form-group-v4">
                                <label>Data & Hora</label>
                                <input type="datetime-local" id="f-data" class="form-control-v4" required>
                            </div>
                            <div class="form-group-v4">
                                <label>Origem (Talhão/Variedade)</label>
                                <input type="text" id="f-origem" class="form-control-v4" placeholder="Ex: Talhão 01 - BMX">
                            </div>
                            <div class="form-group-v4">
                                <label>Nº Romaneio</label>
                                <input type="text" id="f-numero" class="form-control-v4" placeholder="Ex: 123456" required>
                            </div>
                        </div>

                        <div style="display:grid; grid-template-columns:repeat(4, 1fr); gap:15px; margin-bottom:20px;">
                            <div class="form-group-v4">
                                <label>Motorista</label>
                                <input type="text" id="f-motorista" class="form-control-v4" placeholder="Nome do motorista">
                            </div>
                            <div class="form-group-v4">
                                <label>Placa Veículo</label>
                                <input type="text" id="f-placa" class="form-control-v4" placeholder="ABC-1234">
                            </div>
                            <div class="form-group-v4">
                                <label>Frete (R$/ton)</label>
                                <input type="number" id="f-frete-preco" class="form-control-v4" placeholder="0.00" oninput="window.FazendaRP.Pages.Safra.Colheita.calcFrete()">
                            </div>
                            <div class="form-group-v4">
                                <label>Valor Total (R$)</label>
                                <div style="display:flex; gap:5px;">
                                    <input type="number" id="f-frete-valor" class="form-control-v4" placeholder="0.00" step="0.01">
                                    <label style="display:flex; align-items:center; gap:5px; font-size:0.8rem; background:#fff; border:1px solid #e2e8f0; padding:0 8px; border-radius:6px; white-space:nowrap;" title="Gerar conta a pagar">
                                        <input type="checkbox" id="f-frete-cp" style="accent-color:#15803d;"> CP
                                    </label>
                                </div>
                            </div>
                        </div>

                        <h4 style="margin:25px 0 15px 0; border-bottom:2px solid #e5e7eb; padding-bottom:8px; color:#1e293b; font-weight:600;">
                            <i class="fas fa-weight" style="color:#15803d;"></i> Pesagem & Classificação
                        </h4>
                        <div style="display:grid; grid-template-columns:repeat(4, 1fr); gap:15px; margin-bottom:20px;">
                            <div class="form-group-v4">
                                <label>Peso Bruto (kg)</label>
                                <input type="number" id="inp-bruto" class="form-control-v4" value="0" oninput="window.FazendaRP.Pages.Safra.Colheita.calcNet()">
                            </div>
                            <div class="form-group-v4">
                                <label>Tara (kg)</label>
                                <input type="number" id="inp-tara" class="form-control-v4" value="0" oninput="window.FazendaRP.Pages.Safra.Colheita.calcNet()">
                            </div>
                            <div class="form-group-v4">
                                <label>Umidade (%)</label>
                                <input type="number" id="inp-umid" class="form-control-v4" value="0" step="0.1" oninput="window.FazendaRP.Pages.Safra.Colheita.calcNet()">
                                <small style="color:#ef4444; font-size:0.75rem; display:none; margin-top:4px;" id="warn-umid">⚠️ Acima de 14%</small>
                            </div>
                            <div class="form-group-v4">
                                <label>Impureza (%)</label>
                                <input type="number" id="inp-imp" class="form-control-v4" value="0" step="0.1" oninput="window.FazendaRP.Pages.Safra.Colheita.calcNet()">
                            </div>
                        </div>

                        <div style="background:linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%); padding:20px; border-radius:10px; border:1px solid #86efac;">
                            <div style="display:flex; justify-content:space-between; margin-bottom:12px; font-size:0.9rem; color:#166534;">
                                <span style="font-weight:500;">Peso Líquido Inicial (Úmido):</span>
                                <span id="res-liq-ini" style="font-weight:700;">0 kg</span>
                            </div>
                            
                            <div style="display:grid; grid-template-columns:1fr 1fr; gap:12px; margin:15px 0;">
                                <div class="form-group-v4">
                                    <label style="font-size:0.8rem; color:#dc2626; font-weight:600;">Desc. Umidade (kg)</label>
                                    <input type="number" id="inp-desc-umid" class="form-control-v4" style="color:#dc2626; font-weight:bold; border-color:#fca5a5;" value="0" oninput="window.FazendaRP.Pages.Safra.Colheita.calcFinal()">
                                </div>
                                <div class="form-group-v4">
                                    <label style="font-size:0.8rem; color:#dc2626; font-weight:600;">Desc. Impureza (kg)</label>
                                    <input type="number" id="inp-desc-imp" class="form-control-v4" style="color:#dc2626; font-weight:bold; border-color:#fca5a5;" value="0" oninput="window.FazendaRP.Pages.Safra.Colheita.calcFinal()">
                                </div>
                            </div>

                            <div style="border-top:2px solid #86efac; padding-top:15px; margin-top:10px; display:flex; justify-content:space-between; align-items:center;">
                                <span style="font-weight:700; color:#15803d; font-size:1rem;">PESO LÍQUIDO FINAL (Pagável):</span>
                                <span id="res-final" style="font-weight:700; color:#15803d; font-size:1.3rem;">0 kg</span>
                            </div>
                        </div>

                        <div style="margin-top:25px; display:flex; justify-content:flex-end; gap:12px;">
                            <button type="button" class="btn-v4 btn-secondary">
                                <i class="fas fa-times"></i> Limpar
                            </button>
                            <button type="submit" class="btn-v4 btn-primary">
                                <i class="fas fa-check"></i> Registrar Entrada
                            </button>
                        </div>
                    </form>
                </div>

                <!-- Right Side: Destination -->
                <div style="background:white; border-radius:12px; padding:20px; box-shadow:0 1px 3px rgba(0,0,0,0.05); border:1px solid #e5e7eb; height:fit-content;">
                    <h3 style="margin:0 0 15px 0; color:#1e293b; font-weight:600; font-size:1rem;">
                        <i class="fas fa-route" style="color:#15803d;"></i> Destino da Carga
                    </h3>
                    <div class="form-group-v4" style="margin-bottom:15px;">
                        <label>Tipo de Destino</label>
                        <select id="sel-dest" class="form-control-v4" onchange="window.FazendaRP.Pages.Safra.Colheita.toggleContract()">
                            <option value="contrato">Entregar em Contrato</option>
                            <option value="armazem">Armazenar (Estoque Físico)</option>
                            <option value="spot">Venda Imediata (Spot)</option>
                        </select>
                    </div>

                    <div id="area-contract">
                        <div class="form-group-v4">
                            <label>Selecionar Contrato</label>
                            <select id="sel-contrato-id" class="form-control-v4" style="border-left:3px solid #f59e0b;">
                                <option value="">Carregando...</option>
                            </select>
                        </div>
                    </div>

                    <div id="area-armazem" style="display:none">
                        <div class="form-group-v4">
                            <label>Local de Armazenagem</label>
                            <input type="text" id="f-local-armazem" class="form-control-v4" placeholder="Ex: Silo 1">
                        </div>
                    </div>
                </div>
            </div>`;

        // Inject V4 Styles
        this.injectStyles();

        // Load Contracts for Dropdown
        await this.loadContractsDropdown();

        // Build Date
        const now = new Date();
        now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
        document.getElementById('f-data').value = now.toISOString().slice(0, 16);
    },

    injectStyles: function () {
        if (document.getElementById('safra-form-v4-styles')) return;
        const style = document.createElement('style');
        style.id = 'safra-form-v4-styles';
        style.innerHTML = `
            .form-group-v4 { margin-bottom: 0; }
            .form-group-v4 label {
                display: block; font-size: 0.85rem; color: #64748b; margin-bottom: 6px; font-weight: 500;
            }
            .form-control-v4 {
                width: 100%; padding: 10px 12px; border: 1px solid #e2e8f0; border-radius: 8px;
                box-sizing: border-box; font-size: 0.95rem; transition: all 0.2s;
            }
            .form-control-v4:focus {
                outline: none; border-color: #15803d; box-shadow: 0 0 0 3px rgba(21,128,61,0.1);
            }
        `;
        document.head.appendChild(style);
    },

    toggleContract: function () {
        const val = document.getElementById('sel-dest').value;
        document.getElementById('area-contract').style.display = (val === 'contrato') ? 'block' : 'none';
        document.getElementById('area-armazem').style.display = (val === 'armazem') ? 'block' : 'none';
    },

    loadContractsDropdown: async function () {
        const sel = document.getElementById('sel-contrato-id');
        const { data: contratos } = await window.FazendaRP.supabase
            .from('safras_contratos')
            .select('id, numero_contrato, parceiros(nome)')
            .eq('status', 'Aberto')
            .order('created_at', { ascending: false });

        if (contratos && contratos.length > 0) {
            sel.innerHTML = contratos.map(c => `<option value="${c.id}">${c.numero_contrato} - ${c.parceiros?.nome}</option>`).join('');
        } else {
            sel.innerHTML = '<option value="">Nenhum contrato aberto encontrado</option>';
        }
    },

    calcNet: function () {
        const bruto = parseFloat(document.getElementById('inp-bruto').value) || 0;
        const tara = parseFloat(document.getElementById('inp-tara').value) || 0;
        const umid = parseFloat(document.getElementById('inp-umid').value) || 0;
        const imp = parseFloat(document.getElementById('inp-imp').value) || 0;

        const liqIni = Math.max(0, bruto - tara);

        // Auto-Suggest Discounts
        let descUmid = 0;
        if (umid > 14) {
            const diff = umid - 14;
            descUmid = liqIni * (diff * 1.5 / 100);
            document.getElementById('warn-umid').style.display = 'block';
        } else {
            document.getElementById('warn-umid').style.display = 'none';
        }

        let descImp = 0;
        if (imp > 1) {
            const diff = imp - 1;
            descImp = liqIni * (diff / 100);
        }

        // Update Input Fields (Only if not focused)
        const elUmid = document.getElementById('inp-desc-umid');
        const elImp = document.getElementById('inp-desc-imp');

        if (document.activeElement !== elUmid) elUmid.value = Math.round(descUmid);
        if (document.activeElement !== elImp) elImp.value = Math.round(descImp);

        document.getElementById('res-liq-ini').innerText = liqIni.toLocaleString('pt-BR') + ' kg';
        this.calcFrete(); // Update freight if weight changes
        this.calcFinal();
    },

    calcFinal: function () {
        const bruto = parseFloat(document.getElementById('inp-bruto').value) || 0;
        const tara = parseFloat(document.getElementById('inp-tara').value) || 0;
        const liqIni = Math.max(0, bruto - tara);

        const descUmid2 = parseFloat(document.getElementById('inp-desc-umid').value) || 0;
        const descImp2 = parseFloat(document.getElementById('inp-desc-imp').value) || 0;

        const finalKg = liqIni - descUmid2 - descImp2;
        const finalSc = finalKg / 60;

        document.getElementById('res-final').innerText = finalKg.toLocaleString('pt-BR', { maximumFractionDigits: 0 }) + ' kg (' + finalSc.toLocaleString('pt-BR', { maximumFractionDigits: 1 }) + ' sc)';
    },

    saveRomaneio: async function () {
        // Collect Data
        const payload = {
            data_colheita: document.getElementById('f-data').value,
            numero_romaneio: document.getElementById('f-numero').value,
            // Assuming Safra ID is fixed for now or logic needed to get active safra
            safra_id: 1, // TODO: Get Active Safra ID from System
            talhao_origem: document.getElementById('f-origem').value,
            motorista: document.getElementById('f-motorista').value,
            placa_veiculo: document.getElementById('f-placa').value,
            peso_bruto: parseFloat(document.getElementById('inp-bruto').value),
            tara: parseFloat(document.getElementById('inp-tara').value),
            peso_liquido_inicial: parseFloat(document.getElementById('inp-bruto').value) - parseFloat(document.getElementById('inp-tara').value),
            umidade_percentual: parseFloat(document.getElementById('inp-umid').value),
            impureza_percentual: parseFloat(document.getElementById('inp-imp').value),
            desconto_umidade_kg: parseFloat(document.getElementById('inp-desc-umid').value),
            desconto_impureza_kg: parseFloat(document.getElementById('inp-desc-imp').value),
            // Calc Final Logic duplicated here? Or trust UI? Trust UI calculation for now but re-calc is safer.
            peso_liquido_final: (parseFloat(document.getElementById('inp-bruto').value) - parseFloat(document.getElementById('inp-tara').value)) - parseFloat(document.getElementById('inp-desc-umid').value) - parseFloat(document.getElementById('inp-desc-imp').value),

            destino_tipo: document.getElementById('sel-dest').value === 'contrato' ? 'Contrato' : (document.getElementById('sel-dest').value === 'spot' ? 'Spot' : 'Armazem'),
            valor_frete: parseFloat(document.getElementById('f-frete-valor').value) || 0,
            gerar_contas_pagar: document.getElementById('f-frete-cp').checked
        };

        if (payload.destino_tipo === 'Contrato') {
            payload.contrato_id = document.getElementById('sel-contrato-id').value;
        } else if (payload.destino_tipo === 'Armazem') {
            payload.local_armazem = document.getElementById('f-local-armazem').value;
        }

        // 1. Insert Romaneio
        const { data: romaneioData, error } = await window.FazendaRP.supabase.from('safras_colheitas').insert([payload]).select();

        if (error) {
            alert("Erro ao salvar: " + error.message);
            return;
        }

        // 2. Generate CP?
        if (payload.gerar_contas_pagar && payload.valor_frete > 0) {
            try {
                const motorista = payload.motorista || 'Motorista Avulso';
                const placa = payload.placa_veiculo || '';
                const pesoTon = (payload.peso_liquido_inicial / 1000).toFixed(2);

                const lancamentoCP = {
                    tipo: 'Despesa',
                    descricao: `Frete Colheita: ${motorista} (${placa}) - ${pesoTon} ton`,
                    valor: payload.valor_frete,
                    data_vencimento: payload.data_colheita.split('T')[0], // Due date = Harvest date (adjust as needed)
                    status: 'Pendente',
                    categoria: '3.1.2 - Fretes e Carretos', // Example code - ideally fetch ID
                    detalhes: { origem: 'Safra', romaneio: payload.numero_romaneio }
                };

                await window.FazendaRP.supabase.from('financeiro_lancamentos').insert([lancamentoCP]);
                alert("Romaneio e Conta a Pagar gerados com sucesso!");

            } catch (err) {
                console.error(err);
                alert("Romaneio salvo, mas erro ao gerar financeiro: " + err.message);
            }
        } else {
            alert("Romaneio registrado com sucesso!");
        }

        // Reset?
        // document.getElementById('form-romaneio').reset();
    }
};
